import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import notifications from '../../../../redux/notifications/actions';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import { tableConfig } from '../../../../settings/index';

const api = new Api('positions');

export function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', job_types: jobTypes = [] } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter, job_types: jobTypes } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          filters,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
